import styled from "styled-components";

export const PatientInfo = styled.div`
  width: 100%;
  height: 100%; 
  display: flex;
  flex-direction: column;
  .header {
    display: flex;
    margin: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #CFD3DD;
    justify-content: space-between;
    height: 47px;
    align-items: center;
    &__right {
      display: flex;
      align-items: center;
    }
    &__left {
      display: flex;
      align-items: center;
    }
    &__text {
      color: #3E3E5B;
      font-size: 20px;
      font-weight: 700;
    }
    &__button {
      &--margin-right {
        margin-right: 20px;
      }
      &--margin-left {
        margin-left: 20px;
      }
    }
  }
  .inputs-container {
    max-height: 550px;
    overflow-y: auto;
    flex: 1;
    padding: 0 20px;  
    .inputs-title {
      color: #707582;
      font-size: 17px;
      font-family: Nunito Sans Bold;
      padding: 40px 0 20px;
      border-top: 1px solid var(--Backgrounds-Separador-I, #CFD3DD);
      margin-top: 20px;
    }
    .inputs-flex {
      display: flex;
      width: 100%;
      align-items: center;
      margin-bottom: 15px;
      .input-content {
        width: 100%;
      }
      .input-label {
        width: 100%;
        align-items: center;
        margin-bottom: 15px;
      }
      .input-separator {
        width: 20px;  
      }
    }
  }
`